import { ChecklistSection, ApiChecklistSection, FirestoreChecklistSection } from './ChecklistSection';
import { FixedSections, ApiFixedSections, FirestoreFixedSections } from './FixedSections';

type SectionsRecordType = Record<string, ChecklistSection>;
type ApiSectionsRecordType = Record<string, ApiChecklistSection>;
type FirestoreSectionsRecordType = Record<string, FirestoreChecklistSection>;

export type Checklist = {
  fixed: FixedSections;
  house: SectionsRecordType;
  externalArea: SectionsRecordType;
  generalConditions: SectionsRecordType;
}

export type ApiResponseChecklist = {
  fixed: ApiFixedSections;
  house: ApiSectionsRecordType;
  externalArea: ApiSectionsRecordType;
  generalConditions: SectionsRecordType;
}

export type FirestoreResponseChecklist = {
  fixed?: FirestoreFixedSections;
  house?: FirestoreSectionsRecordType;
  externalArea?: FirestoreSectionsRecordType;
  generalConditions: FirestoreSectionsRecordType;
}

export const fromApiToStore = (checklist: ApiResponseChecklist): Checklist => ({ ...checklist });

export const fromFirestoreToStore = (checklist: FirestoreResponseChecklist): Checklist => ({
  fixed: checklist.fixed || {} as FixedSections,
  house: checklist.house || {} as SectionsRecordType,
  externalArea: checklist.externalArea || {} as SectionsRecordType,
  generalConditions: checklist.generalConditions || {}
});
